import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    component: () => import('../views/index.vue'),
    children: [
      {
        name: '首页',
        path: '/home',
        component: () => import('../views/home/index.vue')
      },
      {
        name: '课程',
        path: '/course',
        component: () => import('../views/course/index.vue'),
        children: [
          {
            name: '行业课程',
            path: 'industry',
            component: () => import('../views/course/industry.vue')
          },
          {
            path: 'industryList',
            name: '行业课程列表',
            component: () => import('../views/course/industryList.vue')
          },
          {
            path: 'education',
            name: '教育课程',
            component: () => import('../views/course/education.vue')
          },
          {
            path: 'educationList',
            name: '教育课程列表',
            component: () => import('../views/course/educationList.vue')
          },
          {
            path: 'educationList1',
            name: '教育课程列表1',
            component: () => import('../views/course/educationList1.vue')
          },
        ]
        // component: () => import('../views/login/index.vue')
        // component: () => import('../views/course/index.vue')
      },
      {
        path: '/live',
        name: '直播',
        component: () => import('../views/live/index.vue')
      },
      {
        path: '/repair',
        name: '维修',
        component: () => import('../views/repair/index.vue')
      },
      {
        path: '/case',
        name: '案例',
        component: () => import('../views/case/index.vue')
      },
      {
        path: '/writeCase',
        name: '写案例',
        component: () => import('../views/case/writeCase.vue')
      },
      {
        path: '/findCustomer',
        name: '找客服',
        component: () => import('../views/case/findCustomer.vue')
      },
      {
        path: '/askQuestion',
        name: '咨询',
        component: () => import('../views/case/askQuestion.vue')
      },
      {
        path: '/caseDetail',
        name: '案例详情',
        component: () => import('../views/case/details.vue')
      },
      {
        path: '/answerDetails',
        name: '问答详情',
        component: () => import('../views/case/answerDetails.vue')
      },
      {
        path: '/question',
        name: '题库',
        component: () => import('../views/question/index.vue')
      },
      {
        path: '/exam',
        name: '考试',
        component: () => import('../views/exam/index.vue'),
        children: [
          {
            path: 'examList',
            name: '考试列表',
            component: () => import('../views/exam/examList.vue')
          },
          {
            path: 'grade',
            name: '成绩管理',
            component: () => import('../views/exam/grade.vue')
          },
          {
            path: 'add',
            name: '添加试卷',
            component: () => import('../views/exam/add.vue')
          },
          {
            path: 'edit',
            name: '编辑试卷',
            component: () => import('../views/exam/edit.vue')
          },
          {
            path: 'preview',
            name: 'PaperPreview',
            component: () => import('../views/exam/paperPreview.vue')
          },
          {
            path: 'detail',
            name: '试卷详情',
            component: () => import('../views/exam/gradeDetail.vue')
          },
          {
            path: 'timer',
            name: '考试计时',
            component: () => import('../views/exam/examTiming.vue')
          },
        ]
      },

      {
        path: '/shop',
        name: '店铺',
        component: () => import('../views/shop/index.vue')
      },
      {
        path: '/customer',
        name: '客服',
        component: () => import('../views/case/customer.vue')
      }
    ]
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: function () {
  //     return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  //   }
  // }
  {
    path: '/user',
    name: 'user',
    redirect: '/user/my',
    component: () => import('../views/user/index.vue'),
    children: [
      {
        path: 'my',
        name: 'my',
        component: () => import('../views/user/user.vue')
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('../views/user/components/history/index.vue')
      },
      {
        path: 'collection',
        name: 'collection',
        component: () => import('../views/user/components/collection/index.vue')
      },
      {
        path: 'wrongAnswer',
        name: 'wrongAnswer',
        component: () => import('../views/user/components/wrongAnswer/index.vue')
      },
      {
        path: 'note',
        name: 'note',
        component: () => import('../views/user/components/note/index.vue')
      },
      {
        path: 'noteList',
        name: 'noteList',
        component: () => import('../views/user/components/note/list.vue')
      },
      {
        path: 'commentary',
        name: 'commentary',
        component: () => import('../views/user/components/commentary/index.vue')
      },
      {
        path: 'published',
        name: 'published',
        component: () => import('../views/user/components/published/index.vue')
      },
      {
        path: 'order',
        name: 'order',
        component: () => import('../views/user/components/order/index.vue')
      },
      {
        path: 'order/invoice-history',
        name: 'invoiceHistory',
        component: () => import('../views/user/components/order/InvoiceHistory.vue')
      },
      {
        path: 'address',
        name: 'address',
        component: () => import('../views/user/components/address/index.vue')
      },
      {
        path: 'score',
        name: 'score',
        component: () => import('../views/user/components/score/index.vue')
      },
      {
        path: 'setting',
        name: 'setting',
        component: () => import('../views/user/components/setting/index.vue')
      },
      {
        path: 'agreement',
        name: 'agreement',
        component: () => import('../views/user/components/agreement.vue')
      },
      {
        path: 'agreepayment',
        name: 'agreepayment',
        component: () => import('../views/user/components/agreepaymentvue.vue')
      }
    ]
  },
  {
    path: '/educationDetail',
    name: 'educationDetail',
    component: () => import('../views/course/educationDetail.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/login/register.vue')
  },
  {
    path: '/draw',
    name: 'repairDraw',
    component: () => import('../views/repair/draw.vue')
  },
  {
    path: '/draw1',
    name: 'repairDraw1',
    component: () => import('../views/repair/draw1.vue')
  },
  {
    path: '/draw2',
    name: 'repairDraw2',
    component: () => import('../views/repair/draw2.vue')
  },
  {
    path: '/draw3',
    name: 'repairDraw3',
    component: () => import('../views/repair/draw3.vue')
  },
  {
    path: '/problems',
    name: 'problems',
    component: () => import('../views/question/problems.vue')
  },
  {
    path: '/paper',
    name: 'paper',
    component: () => import('../views/question/paper.vue')
  },
  {
    path: '/examEntry',
    name: '学生答题入口',
    component: () => import('../views/exam/studentEntry.vue')
  },
  {
    path: '/examDetail',
    name: '考试详情',
    component: () => import('../views/exam/examDetail.vue')
  },
  {
    path: '/examSettings',
    name: '考试设置',
    component: () => import('../views/exam/examSettings.vue'),
  },
  {
    path: '/liveDetail',
    name: '直播详情',
    component: () => import('../views/live/details.vue')
  },
  {
    path: '/search',
    name: '搜索',
    component: () => import('../views/case/search.vue')
  },
  {
    path: '/liveHui',
    name: '直播',
    component: () => import('../views/live/hui.vue')
  },
  {
    path: '/repairList',
    name: '报修列表',
    component: () => import('../views/repair/list.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫：先做登录校验，再根据路由 meta.groups 做简单角色控制
router.beforeEach((to, from, next) => {
  const publicPaths = [
    "/login",
    "/register",
    "/examEntry",
    "/examDetail",
    "/problems",
    "/paper",
  ];

  // 公开路由直接放行（这些路由不做登录与角色校验）
  if (publicPaths.includes(to.path)) return next();

  // 登录校验
  const token = window.localStorage.getItem("token");
  if (!token) return next("/login");

  // 角色校验（默认对所有用户开放：
  // 只有当路由配置了 meta.groups 且当前 group_id 不在列表中时才拦截）
  const userinfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
  console.log(userinfo, 'userinfo');
  const groupId = Number(userinfo.group_id || 0);
  console.log(groupId, 'groupId');
  const needGroups = to.meta && to.meta.groups;

  if (Array.isArray(needGroups) && needGroups.length > 0) {
    if (!needGroups.includes(groupId)) {
      return next("/home");
    }
  }

  next();
})

export default router
